interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Simple line-style table glyph for "no data to show" empty states. */
const NoTableDataIcon = ({ width = 48, height = 48, color = '#C4CBD6' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect x='6' y='8' width='36' height='32' rx='3' stroke={color} strokeWidth='2.5' />
      <path d='M6 18H42' stroke={color} strokeWidth='2.5' />
      <path d='M6 28H42' stroke={color} strokeWidth='2.5' />
      <path d='M18 8V40' stroke={color} strokeWidth='2.5' />
      <path d='M30 8V40' stroke={color} strokeWidth='2.5' />
    </svg>
  );
};

export default NoTableDataIcon;
